/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-nested-ternary */
import {
  useCallback, useEffect, useMemo, useState,
} from 'react';

import {
  useNavigate, NavigateFunction, useSearchParams, useLocation,
  Navigate,
} from 'react-router-dom';
import {
  useDispatch, useSelector,
} from 'react-redux';
import { actions } from 'Slice/GlobalSearchResultsSlice';

import ArticlesSection from 'Components/globalSearch/components/ArticlesSection';
import InfiniteScroll from 'react-infinite-scroll-component';
import { usePrevious } from 'Utils/hooks/usePrevious';
import SocialCardSkeleton from 'Components/common/skeleton/SocialCardSkeleton';
import {
  articlesData, companiesData, peopleData, selectCompanyLoaded,
  selectLoading, selectPersonLoaded, selectSearchLoaded,
  selectPersonLoading, selectCompanyLoading, industriesData,
  selectSearchText, buyerGroupsData, selectBuyerGroupsLoading,
  documentData,
  selectGlobalSearchScreenName,
  selectSelectedCompanies,
  selectSelectedPeople,
  selectLinkedinPersonLoaded,
  selectIsResultsDerived,
} from 'Selector/GlobalSearchResultsSelector';
import SelectionActionFooter from 'Components/common/components/SelectionActionFooter';

import SearchCompanySkeletonBlock from 'Components/common/skeleton/SearchCompanySkeletonBlock';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import SearchIndustrySkeletonBlock from 'Components/common/skeleton/SearchIndustrySkeletonBlock';
import IndustriesSection from 'Components/globalSearch/components/IndustriesSectionGlobalSearch';
import SearchNoResultFoundWidget from 'Components/common/components/SearchNoResultFoundWidget';

import { selectScreenName, selectShowGlobalGilroy } from 'Selector/GlobalSearchContentSelector';
import DrawerPeopleGroup from 'Components/people/components/DrawerPeopleGroup';
import { actions as groupActions } from 'Slice/GroupsSlice';
import { selectGroupDrawerOpen } from 'Selector/GroupsSelector';
import {
  COMPANY_NEWS_ROUTE, FEED_GILROY_ROUTE, ONBOARDING, PERSONALITY_INSIGHTS_ROUTE,
  SEARCH_PATHNAME_PREFIX,
  SALESFORCE_COMPANY_SEARCH_ROUTE,
  SALESFORCE_PERSON_SEARCH_ROUTE,
  SORTABLE_SECTIONS,
  GLOBAL_FILTER_PARAMS,
} from 'Utils/Constants';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { selectData } from 'Selector/CertificationSelector';
import {
  ArticleSlicerResultPage,
  GroupSlicerResultPage, IsTablet, SlicerResultPage, getLangCookie, isSalesforce,
  isEnterpriseUser,
} from 'Utils/UtilityFunctions';
import BuyerGroupsSection from 'Components/common/components/BuyerGroupsSection';

import SearchBuyerGroupSkeletonBlock from 'Components/common/skeleton/SearchBuyerGroupSkeltonBlock';
import SubNavBarPrimary from 'Components/layout/headers/SubNavBarPrimary';
import ViewTabs from 'Components/common/tabs/ViewTabs';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import classNames from 'classnames';
import styled from 'styled-components';
import { actions as UiAction } from 'Slice/UISlice';
import { DateRangeValue, ViewInterface, CompanyFiltersType, PeopleFilterSelections } from 'Types/GlobalTypes';
import { selectViewTab } from 'Selector/UISelector';
import {
  extendedSearchLoader,
  maxMobile,
  maxTablet,
  maxWidth,
  primaryColor,
  primaryFont,
  primaryHeadingColor,
  retina,
  secondaryFont,
  smMobile,
  wMBold,
} from 'Utils/utilsStyle';
import PeopleSectionListView from 'Components/common/components/PeopleSectionListView';
import CompaniesSectionListView from 'Components/common/components/CompaniesSectionListView';
import BuyerGroupsSectionListView from 'Components/common/components/BuyerGroupsSectionListView';
import ArticlesSectionListView from 'Components/globalSearch/components/ArticlesSectionListView';
import DocumentHub from 'Pages/document/DocumentHub';
import DocumentHubListView from 'Pages/document/DocumentHubListView';
import IndustriesSectionListView from 'Components/globalSearch/components/IndustriesSectionListView';
import { Gilroy } from 'gilroy-global';
import { useGilroy } from 'Utils/hooks/useGilroy';
import ExtendedSearchLoader from 'Components/common/components/ExtendedSearchLoader';
import SearchPersonSkeletonBlock from '../../Components/common/skeleton/SearchPersonSkeletonBlock';
import {
  SearchResultsRequest,
} from '../../Types/GlobalSearchResultsTypes';

import BackIcon from '../../Components/common/assets/svgIcons/BackIcon';
import DrawerAlerts from '../../Components/alerts/components/DrawerAlerts';
import NavBarPrimary, { chatActions, chatStates } from '../../Components/layout/headers/NavBarPrimary';
import GlobalSearch from '../../Components/globalSearch/components/GlobalSearch';
import CompaniesSection from '../../Components/common/components/CompaniesSection';
import PeopleSection from '../../Components/common/components/PeopleSection';
import DrawerAccountCluster from '../../Components/company/components/DrawerAccountCluster';
import { actions as clusterActions } from '../../Slice/ClustersSlice';
import { selectClusterDrawerOpen } from '../../Selector/ClustersSelector';
import DrawerPersonas from '../../Components/people/components/DrawerPersonas';
import PeopleFilters from '../../Components/common/components/PeopleFilters';
import CompanyFilters from '../../Components/common/components/CompanyFilters';
import CustomSort, { SortOrder } from '../../Components/common/components/CustomSort';
import DateRangeFilter from '../../Components/common/components/DateRangeFilter';
import { selectAdvanceSearchMetadata } from '../../Selector/AdvanceSearchSelector';
import { actions as filterActions } from '../../Slice/FilterSlice';
import { selectDistinctCompany, selectDistinctCompanyCount, selectDistinctCompanyLoading, selectDistinctCompanyPage, selectDistinctCompanySearchTerm, selectDistinctDesignation, selectDistinctDesignationCount, selectDistinctDesignationLoading, selectDistinctDesignationPage, selectDistinctDesignationSearchTerm, selectSearchDistinctFilters } from '../../Selector/FilterSelector';

export type SearchResultsRouteState = {
  enableBackButton?: boolean
  hideBackIcon?: boolean
  query: string
  previousPath?: string
};
type Props = {
  hideNavbar?: boolean,
  hideArticles?: boolean,
  forceSearch?: boolean,
  onboardingSearchFlag?: boolean,
  hideIndustries?: boolean
} & typeof defaultProps;

const defaultProps = {
  hideNavbar: false,
  hideArticles: false,
  forceSearch: false,
  onboardingSearchFlag: false,
  hideIndustries: false,
};

const parseCompanyFilter = (value: string | null, allOptions: string[]) => {
  if (!value) {
    return undefined;
  }
  if (value === 'selectAll') {
    return allOptions.length ? allOptions : undefined;
  }
  try {
    const parsedValue: unknown = JSON.parse(value);
    return Array.isArray(parsedValue)
      ? parsedValue.filter((option): option is string => typeof option === 'string')
      : undefined;
  } catch {
    return undefined;
  }
};

const Wrapper = styled.div`
.boxDoor{
  z-index: 3;
}
.container {
  margin-bottom: 100px;
  @media all and (max-width: ${maxTablet}) {
    margin-bottom: 0px;
  }
}
.person-item {
  margin-bottom: 0px;
}
.small-button-chinese{
  margin-bottom: 0px;
}
.M-companies .companies-margin {
  .ant-row {
    &.Grid-width-row {
      &.col-six-fix-md {
        margin-top: 0px;
      }
    } 
  }
}
.company-image-parent {
  @media all and (max-width: ${smMobile}) {
    margin-bottom: 4px;
  }
}
.right-side-sub-header {
  .global-search-sort {
    margin-right: 6px;
    @media all and (max-width: ${maxMobile}) {
      margin: auto 6px;
    }
  }
  .global-search-sort button,
  .people-filter button,
  .company-filter button {
    height: 36px;
    min-height: 36px;
    padding: 4px 12px;
  }
  .date-filter-btn {
    height: 36px;
    min-height: 36px;
    padding-top: 4px;
    padding-bottom: 4px;
  }
  .view-tabs {
    height: 36px;
    .tabs-wrapper {
      height: 36px;
      .tabs-item {
        height: 36px;
        padding: 4px 10px;
      }
    }
  }
  @media all and (max-width: ${maxWidth}) , ${retina} {
    .global-search-sort button,
    .people-filter button,
    .company-filter button {
      height: 30px;
      min-height: 30px;
      padding: 4px 12px;
    }
    .date-filter-btn {
      height: 30px;
      min-height: 30px;
      padding-top: 4px;
      padding-bottom: 4px;
    }
    .view-tabs {
      height: 30px;
      .tabs-wrapper {
        height: 30px;
        .tabs-item {
          height: 30px;
          min-height: 30px;
          width: 34px;
          min-width: 34px;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          svg {
            height: 14px;
            width: auto;
            min-width: 0;
          }
        }
      }
    }
  }
  @media all and (max-width: ${maxTablet}) {
    .global-search-sort button,
    .people-filter button,
    .company-filter button,
    .date-filter-btn {
      height: 26px !important;
      min-height: 26px;
    }
    .view-tabs {
      height: 26px;
      .tabs-wrapper {
        height: 26px;
        .tabs-item {
          height: 26px;
          min-height: 26px;
        }
      }
    }
  }
}
`;


const LoaderWrapper = styled.div`
  width: 100%;
  .main {
    background:white;
    border:1px solid ${primaryColor};
    padding: 5px 10px;
    text-align: center;
    border-radius: 10px;
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0px;
    .loader-style{
      height: 30px;
      width: 30px;
      margin-right: 10px;
    }
    .text{
      font-size: 16px;
      color:${primaryHeadingColor};
      font-weight: ${wMBold};
      font-family: ${secondaryFont};
      letter-spacing: -0.45px;
      line-height: 14px;
      margin-bottom: 0px;
    }
  }
`;

const NoPersonFound = styled.span`
  padding: 20px;
  min-height: 250px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 16px;
  color: rgb(126, 126, 126);
  font-family: ${primaryFont};
`;
const Search = function Search({
  hideNavbar,
  hideArticles,
  forceSearch,
  onboardingSearchFlag,
  hideIndustries,
}: Props) {
  const dispatch = useDispatch();
  const { gilroyStates, gilroyActions } = useGilroy();
  const { saveUrl: savedUrlV2 } = chatStates;
  const isEnterprise = isEnterpriseUser();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [dragging, setDragging] = useState(false);
  // Marks the buyer group drawer as opened from the selection footer, so the create
  // call is seeded with the checked people instead of a dragged person.
  const [createFromSelection, setCreateFromSelection] = useState(false);
  const [top, setTop] = useState(0);
  const loading: boolean = useSelector(selectLoading);
  const peopleCollection = useSelector(peopleData);
  const documentCollection = useSelector(documentData);
  const companiesCollection = useSelector(companiesData);
  const buyerGroupsCollection = useSelector(buyerGroupsData);
  const articlesCollection = useSelector(articlesData);
  const industriesCollection = useSelector(industriesData);
  const personsLoaded = useSelector(selectPersonLoaded);
  const companiesLoaded = useSelector(selectCompanyLoaded);
  const personsLoading: boolean = useSelector(selectPersonLoading) ?? false;
  const linkedinpersonLoaded: boolean = useSelector(selectLinkedinPersonLoaded) ?? false;
  const companiesLoading: boolean = useSelector(selectCompanyLoading) ?? false;
  const buyerGroupsLoading: boolean = useSelector(selectBuyerGroupsLoading) ?? false;
  const globalSearchLoaded = useSelector(selectSearchLoaded);
  const screenName = useSelector(selectScreenName);
  const searchText = useSelector(selectSearchText);
  const isResultsDerived = useSelector(selectIsResultsDerived);
  const showGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const currentUrl = window.location.href;
  const slicerNumber: number = SlicerResultPage();
  const slicerGroupNumber: number = GroupSlicerResultPage();
  const slicerArticleNumber: number = ArticleSlicerResultPage();
  const tabView: ViewInterface = useSelector(selectViewTab);
  const isListView = tabView.view === 'listView';
  const isTablet = IsTablet();
  const location = useLocation();
  const { state } = location;
  const enableBackButton: boolean = (state as SearchResultsRouteState)?.enableBackButton ?? false;
  const [searchParams] = useSearchParams();
  const previousPath = (state as SearchResultsRouteState)?.previousPath ?? FEED_GILROY_ROUTE;
  const clusterDrawerOpen = useSelector(selectClusterDrawerOpen);
  const filters = useSelector(selectAdvanceSearchMetadata);
  const articleFilterStartDate = (searchParams.get('startDate') as string) ?? null;
  const articleFilterEndDate = (searchParams.get('endDate') as string) ?? null;
  const companyFiltersFromUrl = useMemo<CompanyFiltersType>(() => {
    const nextFilters: CompanyFiltersType = {};
    const industry = parseCompanyFilter(
      searchParams.get('industry'),
      filters?.industries?.map((option) => option.name) ?? [],
    );
    const revenue = parseCompanyFilter(searchParams.get('revenue'), filters?.companyRevenue ?? []);
    const region = parseCompanyFilter(searchParams.get('region'), filters?.regions ?? []);
    const size = parseCompanyFilter(searchParams.get('companySize'), filters?.companySizes ?? []);

    if (industry) nextFilters.industry = industry;
    if (revenue) nextFilters.revenue = revenue;
    if (region) nextFilters.region = region;
    if (size) nextFilters.companySize = size;
    return nextFilters;
  }, [
    searchParams,
    filters?.industries,
    filters?.companyRevenue,
    filters?.regions,
    filters?.companySizes,
  ]);

  const distinctCompanyFilters = useSelector(selectDistinctCompany);
  const distinctCompanyPage = useSelector(selectDistinctCompanyPage);
  const distinctCompanyCount = useSelector(selectDistinctCompanyCount);
  const distinctCompanyLoading = useSelector(selectDistinctCompanyLoading);
  const distinctCompanySearchTerm = useSelector(selectDistinctCompanySearchTerm);

  const distinctDesignationFilters = useSelector(selectDistinctDesignation);
  const distinctDesignationPage = useSelector(selectDistinctDesignationPage);
  const distinctDesignationCount = useSelector(selectDistinctDesignationCount);
  const distinctDesignationLoading = useSelector(selectDistinctDesignationLoading);
  const distinctDesignationSearchTerm = useSelector(selectDistinctDesignationSearchTerm);

  const hasMoreDistinctCompanies = distinctCompanyFilters.length < distinctCompanyCount;
  const hasMoreDistinctDesignations = distinctDesignationFilters.length < distinctDesignationCount;

  const peopleFiltersFromUrl = useMemo<PeopleFilterSelections>(() => ({
    jobTitle: parseCompanyFilter(searchParams.get('jobTitle'), distinctDesignationFilters),
    jobLevel: parseCompanyFilter(searchParams.get('jobLevel'), filters?.jobLevels ?? []),
    personality: parseCompanyFilter(
      searchParams.get('personality'),
      filters?.personalityTypes?.map((option) => option.filterName) ?? [],
    ),
    company: parseCompanyFilter(
      searchParams.get('company'),
      distinctCompanyFilters.map((option) => option.companyName),
    ),
    region: parseCompanyFilter(searchParams.get('region'), filters?.regions ?? []),
  }), [
    searchParams,
    distinctDesignationFilters,
    distinctCompanyFilters,
    filters?.jobLevels,
    filters?.personalityTypes,
    filters?.regions,
  ]);

  const setPeopleFilterParams = (
    params: URLSearchParams,
    peopleFilters: PeopleFilterSelections,
  ) => {
    Object.entries(peopleFilters).forEach(([category, selected]) => {
      if (selected?.length) {
        params.set(category, JSON.stringify(selected));
      } else {
        params.delete(category);
      }
    });
  };

  const setCompanyFilterParams = (
    params: URLSearchParams,
    companyFilters: CompanyFiltersType,
  ) => {
    Object.entries(companyFilters).forEach(([category, selected]) => {
      if (selected?.length) {
        params.set(category, JSON.stringify(selected));
      } else {
        params.delete(category);
      }
    });
  };

  const setArticleFilterParams = (
    params: URLSearchParams,
    articleFilters: DateRangeValue,
  ) => {
    if (articleFilters.startDate) params.set('startDate', articleFilters.startDate);
    else params.delete('startDate');
    if (articleFilters.endDate) params.set('endDate', articleFilters.endDate);
    else params.delete('endDate');
    if (articleFilters.type) params.set('type', articleFilters.type);
    else params.delete('type');
  };

  const navigate: NavigateFunction = useNavigate();
  const query = searchParams.get('query') ?? '';
  const hasAppliedFilters = GLOBAL_FILTER_PARAMS.some((param) => {
    const value = searchParams.get(param);
    return Boolean(value && value.trim());
  });

  const extendedSections = ['person', 'company', 'article', 'industry', 'group', 'document'];
  const extendedSection = (searchParams.get('extend') ?? '');
  const prevExtendedSection = usePrevious(extendedSection);
  const isDetailedSearch: boolean = extendedSections.includes(extendedSection);
  const prevIsDetailedSearch = usePrevious(isDetailedSearch);
  const sortOrder = (searchParams.get('sort') as SortOrder | null) ?? null;

  const selectedPeople = useSelector(selectSelectedPeople);
  const groupDrawerOpen = useSelector(selectGroupDrawerOpen);

  const selectedCompanies = useSelector(selectSelectedCompanies);
  const toggleDrawer = () => {
    dispatch(clusterActions.setDrawerOpen(!clusterDrawerOpen));
  };

  const handleCreateAccountCluster = () => {
    dispatch(clusterActions.setDrawerOpen(true));
  };

  const handleAddToBuyerGroup = () => {
    setCreateFromSelection(true);
    setOpenCreateModal(true);
    setShowNew(true);
  };

  const [personPage, setPersonPage] = useState(1);
  const [companyPage, setCompanyPage] = useState(1);
  const [buyerGroupPage, setBuyerGroupPage] = useState(1);
  const [atriclePage, setAtriclePage] = useState(1);
  const [industryPage, setIndustryPage] = useState(1);
  const [documentpage, setDocumentPage] = useState(1);
  const [activeTab, setActiveTab] = useState('');
  const [sectionSortOrders, setSectionSortOrders] = useState<Record<string, SortOrder>>({});
  const [sectionPeopleFilters, setSectionPeopleFilters] = useState<Record<string, PeopleFilterSelections>>({});
  const [sectionCompanyFilters, setSectionCompanyFilters] = useState<Record<string, CompanyFiltersType>>({});
  const [sectionArticleFilters, setSectionArticleFilters] = useState<Record<string, DateRangeValue>>({});

  const hasRememberedSelection = (
    selection?: PeopleFilterSelections | CompanyFiltersType,
  ) => (
    Boolean(selection && Object.values(selection).some((value) => Array.isArray(value) && value.length > 0))
  );

  const hasRememberedArticleFilter = (selection?: DateRangeValue) => (
    Boolean(selection && !selection.allTime && selection.startDate && selection.endDate && selection.type)
  );

  const isPeopleFilterApplied = ['jobTitle', 'jobLevel', 'personality', 'company', 'region']
    .some((param) => Boolean(searchParams.get(param)?.trim()))
    || hasRememberedSelection(sectionPeopleFilters.person);
  const isCompanyFilterApplied = ['industry', 'revenue', 'region', 'companySize']
    .some((param) => Boolean(searchParams.get(param)?.trim()))
    || hasRememberedSelection(sectionCompanyFilters.company);
  const isArticleFilterApplied = ['startDate', 'endDate', 'type']
    .some((param) => Boolean(searchParams.get(param)?.trim()))
    || hasRememberedArticleFilter(sectionArticleFilters.article);

  const queryString = searchParams.get('query') || '';
  const groupId = searchParams.get('groupId') || '';
  const groupIdParsed = groupId ? parseInt(groupId, 10) : 0;
  const globalScreenName = useSelector(selectGlobalSearchScreenName);

  if (isSalesforce()) {
    if (extendedSection === 'person') {
      return <Navigate to={`${SALESFORCE_PERSON_SEARCH_ROUTE}${query}`} state={{ from: 'salesforce-search' }} replace />;
    }
    return <Navigate to={`${SALESFORCE_COMPANY_SEARCH_ROUTE}${query}`} state={{ from: 'salesforce-search' }} replace />;
  }

  const fetchMorePeople = () => {
    if (!loading) {
      setPersonPage(personPage + 1);
      const obj: SearchResultsRequest = {
        query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        page: personPage + 1,
        ...(sortOrder && { sortOrder: sortOrder }),
        ...(peopleFiltersFromUrl.jobTitle && { jobTitles: peopleFiltersFromUrl.jobTitle }),
        ...(peopleFiltersFromUrl.jobLevel && { jobLevels: peopleFiltersFromUrl.jobLevel.join(',') }),
        ...(peopleFiltersFromUrl.personality && { personalityTypes: peopleFiltersFromUrl.personality.join(',') }),
        ...(peopleFiltersFromUrl.company && { companies: peopleFiltersFromUrl.company }),
        ...(peopleFiltersFromUrl.region && { regions: peopleFiltersFromUrl.region }),
        defaultLanguage: getLangCookie(),
      };
      dispatch(actions.globalSearchResults(obj));
    }
  };
  const fetchMoreCompanies = () => {
    if (!loading) {
      setCompanyPage(companyPage + 1);
      const obj: SearchResultsRequest = {
        query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        page: companyPage + 1,
        ...(sortOrder && { sortOrder }),
        ...(companyFiltersFromUrl.industry && { industries: companyFiltersFromUrl.industry }),
        ...(companyFiltersFromUrl.region && { regions: companyFiltersFromUrl.region }),
        ...(companyFiltersFromUrl.revenue && { revenues: companyFiltersFromUrl.revenue }),
        ...(companyFiltersFromUrl.companySize && { companySizes: companyFiltersFromUrl.companySize }),
        defaultLanguage: getLangCookie(),
      };
      dispatch(actions.globalSearchResults(obj));
    }
  };

  const fetchMoreBuyerGroups = () => {
    if (!loading) {
      setBuyerGroupPage(buyerGroupPage + 1);
      const obj: SearchResultsRequest = {
        query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        page: buyerGroupPage + 1,
        ...(sortOrder && { sortOrder }),
        defaultLanguage: getLangCookie(),
      };
      dispatch(actions.globalSearchResults(obj));
    }
  };

  const fetchMoreArticles = () => {
    if (!loading) {
      setAtriclePage(atriclePage + 1);
      const obj: SearchResultsRequest = {
        query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        page: atriclePage + 1,
        ...(isDetailedSearch && extendedSection === 'article' && { type: 'News' }),
        defaultLanguage: getLangCookie(),
        ...(articleFilterStartDate && { startDate: articleFilterStartDate }),
        ...(articleFilterEndDate && { endDate: articleFilterEndDate }),

      };
      dispatch(actions.globalSearchResults(obj));
    }
  };

  const fetchMoreIndustries = () => {
    if (!loading) {
      setIndustryPage(industryPage + 1);
      const obj: SearchResultsRequest = {
        query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        page: industryPage + 1,
        defaultLanguage: getLangCookie(),
      };
      dispatch(actions.globalSearchResults(obj));
    }
  };

  const fetMoreDocuments = () => {
    if (!loading) {
      setDocumentPage(documentpage + 1);
      const obj: SearchResultsRequest = {
        query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        page: documentpage + 1,
        ...(sortOrder && { sortOrder }),
        defaultLanguage: getLangCookie(),
      };
      dispatch(actions.globalSearchResults(obj));
    }
  };

  useEffect(() => {
    if (globalScreenName === 'addCompanyToServiceLine') {
      dispatch(actions.globalSearchResultsResetEmpty());
      const obj: SearchResultsRequest = {
        query: queryString,
        // query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        ...(groupIdParsed && groupIdParsed > 0 && { group_id: groupIdParsed }),
        ...(isDetailedSearch && !isSalesforce() && { page: 1 }),
        // ...(isDetailedSearch && extendedSection === 'article' && { type: 'News' }),
        ...(sortOrder && { sortOrder }),
        ...(isPeopleFilterApplied && { filterApplied: true }),
        // for article filters
        ...(extendedSection === 'article' && articleFilterStartDate && { startDate: articleFilterStartDate }),
        ...(extendedSection === 'article' && articleFilterEndDate && { endDate: articleFilterEndDate }),
        ...(extendedSection === 'person' && peopleFiltersFromUrl.jobTitle && { jobTitles: peopleFiltersFromUrl.jobTitle }),
        ...(extendedSection === 'person' && peopleFiltersFromUrl.jobLevel && { jobLevels: peopleFiltersFromUrl.jobLevel.join(',') }),
        ...(extendedSection === 'person' && peopleFiltersFromUrl.personality && { personalityTypes: peopleFiltersFromUrl.personality.join(',') }),
        ...(extendedSection === 'person' && peopleFiltersFromUrl.company && { companies: peopleFiltersFromUrl.company }),
        ...(extendedSection === 'person' && peopleFiltersFromUrl.region && { regions: peopleFiltersFromUrl.region }),

        defaultLanguage: getLangCookie(),
      };
      setPersonPage(1);
      setCompanyPage(1);
      setAtriclePage(1);
      setIndustryPage(1);
      setBuyerGroupPage(1);
      setDocumentPage(1);
      dispatch(actions.globalSearchResults(obj));
      window.scrollTo(0, 0);
      return;
    }
    if (searchText.split(':').pop() !== queryString || isResultsDerived) {
      dispatch(actions.globalSearchResultsResetEmpty());
      const obj: SearchResultsRequest = {
        query: queryString,
        // query: isDetailedSearch ? `${extendedSection}:${queryString}` : queryString,
        screenName,
        ...(groupIdParsed && groupIdParsed > 0 && { group_id: groupIdParsed }),
        ...(isDetailedSearch && !isSalesforce() && { page: 1 }),
        // ...(isDetailedSearch && extendedSection === 'article' && { type: 'News' }),
        ...(sortOrder && { sortOrder }),
        ...(isPeopleFilterApplied && { filterApplied: true }),
        // for article filters
        ...(extendedSection === 'article' && articleFilterStartDate && { startDate: articleFilterStartDate }),
        ...(extendedSection === 'article' && articleFilterEndDate && { endDate: articleFilterEndDate }),
        ...(isCompanyFilterApplied && companyFiltersFromUrl.industry && { industries: companyFiltersFromUrl.industry }),
        ...(isCompanyFilterApplied && companyFiltersFromUrl.region && { regions: companyFiltersFromUrl.region }),
        ...(isCompanyFilterApplied && companyFiltersFromUrl.revenue && { revenues: companyFiltersFromUrl.revenue }),
        ...(isCompanyFilterApplied && companyFiltersFromUrl.companySize && { companySizes: companyFiltersFromUrl.companySize }),
        ...(isPeopleFilterApplied && peopleFiltersFromUrl.jobTitle && { jobTitles: peopleFiltersFromUrl.jobTitle }),
        ...(isPeopleFilterApplied && peopleFiltersFromUrl.jobLevel && { jobLevels: peopleFiltersFromUrl.jobLevel.join(',') }),
        ...(isPeopleFilterApplied && peopleFiltersFromUrl.personality && { personalityTypes: peopleFiltersFromUrl.personality.join(',') }),
        ...(isPeopleFilterApplied && peopleFiltersFromUrl.company && { companies: peopleFiltersFromUrl.company }),
        ...(isPeopleFilterApplied && peopleFiltersFromUrl.region && { regions: peopleFiltersFromUrl.region }),

        defaultLanguage: getLangCookie(),
      };
      setPersonPage(1);
      setCompanyPage(1);
      setAtriclePage(1);
      setIndustryPage(1);
      setBuyerGroupPage(1);
      setDocumentPage(1);
      dispatch(actions.globalSearchResults(obj));
      window.scrollTo(0, 0);
    }
  }, [query, forceSearch, groupId]);

  useEffect(() => {
    const returnedToBaseSearch = prevIsDetailedSearch && !isDetailedSearch;
    if (!returnedToBaseSearch) {
      return;
    }
    setSectionSortOrders({});
    setSectionPeopleFilters({});
    setSectionCompanyFilters({});
    if (isResultsDerived && !hasAppliedFilters && !sortOrder && queryString) {
      dispatch(actions.globalSearchResultsResetEmpty());
      const obj: SearchResultsRequest = {
        query: queryString,
        screenName,
        ...(groupIdParsed && groupIdParsed > 0 && { group_id: groupIdParsed }),
        defaultLanguage: getLangCookie(),
      };
      setPersonPage(1);
      setCompanyPage(1);
      setAtriclePage(1);
      setIndustryPage(1);
      setBuyerGroupPage(1);
      setDocumentPage(1);
      dispatch(actions.globalSearchResults(obj));
      window.scrollTo(0, 0);
    }
  }, [isDetailedSearch]);

  useEffect(() => {
    if (!globalSearchLoaded && searchText.split(':').pop() !== queryString) {
      window.scrollTo(0, 0);
    }
    if (savedUrlV2 !== currentUrl) {
      dispatch(UiAction.isShowGilroyGlobalToggle(false));
      chatActions.setShowLibrary(true);
      chatActions.setShowExamplePrompts(false);
      chatActions.resetChatHistory();
      chatActions.setSelectedConversationId(-1);
      chatActions.setHistoryPanelOpened(false);
    } else {
      chatActions.setSaveUrl('');
      chatActions.setSaveProfileName('');
    }
    return () => {
      setPersonPage(1);
      setCompanyPage(1);
      setAtriclePage(1);
      setIndustryPage(1);
      setBuyerGroupPage(1);
      dispatch(actions.globalSearchResultsReset());
    };
  }, []);

  // For extended people search (`extend=person`), keep the People section visible
  // as soon as the content search has completed, even if the extended search
  // is still loading. This ensures content-search results render immediately
  // with an extended-search loader, instead of the section disappearing until
  // `personsLoaded` becomes true.
  const isPeopleEmpty = (isDetailedSearch && extendedSection === 'person')
    ? (globalSearchLoaded || personsLoaded)
    : (globalSearchLoaded && (
      (peopleCollection?.persons?.length ?? 0) > 0
      || isPeopleFilterApplied
      || !personsLoaded
    ));
  const isCompaniesEmpty = globalSearchLoaded && (
    ((companiesCollection?.companies?.length ?? 0) > 0) || isCompanyFilterApplied
  );
  const isBuyerGroupsEmpty = ((buyerGroupsCollection?.groups?.length ?? 0) > 0)
    && globalSearchLoaded;
  const isArticlesEmpty = globalSearchLoaded && (
    ((articlesCollection?.articles?.length ?? 0) > 0) || isArticleFilterApplied
  );
  const isIndustriesEmpty = ((industriesCollection?.industries?.length ?? 0) > 0)
    && globalSearchLoaded;

  const isDocumentEmpty = ((documentCollection?.documents?.length ?? 0) > 0)
    && globalSearchLoaded;

  let isPeopleSectionVisible = loading ? true : isPeopleEmpty;
  let isCompaniesSectionVisible = loading ? true : isCompaniesEmpty;
  let isBuyerGroupsSectionVisible = loading ? true : isBuyerGroupsEmpty;
  let isArticlesSectionVisible = loading ? true : isArticlesEmpty;
  let isIndustriesSectionVisible = loading ? true : isIndustriesEmpty;
  let isDocumethubSectionVisible = loading ? true : isDocumentEmpty;
  const { pathname } = useLocation();

  if (extendedSection === 'person') {
    isCompaniesSectionVisible = false;
    isArticlesSectionVisible = false;
    isIndustriesSectionVisible = false;
    isBuyerGroupsSectionVisible = false;
    isDocumethubSectionVisible = false;
  } else if (extendedSection === 'company') {
    isPeopleSectionVisible = false;
    isArticlesSectionVisible = false;
    isIndustriesSectionVisible = false;
    isBuyerGroupsSectionVisible = false;
    isDocumethubSectionVisible = false;
  } else if (extendedSection === 'group') {
    isPeopleSectionVisible = false;
    isCompaniesSectionVisible = false;
    isArticlesSectionVisible = false;
    isIndustriesSectionVisible = false;
    isDocumethubSectionVisible = false;
  } else if (extendedSection === 'article') {
    isCompaniesSectionVisible = false;
    isPeopleSectionVisible = false;
    isIndustriesSectionVisible = false;
    isBuyerGroupsSectionVisible = false;
    isDocumethubSectionVisible = false;
  } else if (extendedSection === 'industry') {
    isCompaniesSectionVisible = false;
    isArticlesSectionVisible = false;
    isPeopleSectionVisible = false;
    isBuyerGroupsSectionVisible = false;
    isDocumethubSectionVisible = false;
  } else if (extendedSection === 'document') {
    isCompaniesSectionVisible = false;
    isArticlesSectionVisible = false;
    isPeopleSectionVisible = false;
    isBuyerGroupsSectionVisible = false;
    isIndustriesSectionVisible = false;
  }
  const personsToDisplay = useMemo(
    () => (isDetailedSearch ? peopleCollection?.persons
      : peopleCollection?.persons?.slice(0, slicerNumber)),
    [isDetailedSearch, peopleCollection?.persons, slicerNumber],
  );
  const personsToDisplayListView = useMemo(
    () => (isDetailedSearch ? peopleCollection?.persons
      : peopleCollection?.persons?.slice(0, 4)),
    [isDetailedSearch, peopleCollection?.persons],
  );
  const companiesToDisplay = isDetailedSearch ? companiesCollection?.companies
    : companiesCollection?.companies?.slice(0, slicerNumber);
  const companiesToDisplayListView = isDetailedSearch ? companiesCollection?.companies
    : companiesCollection?.companies?.slice(0, 4);
  const articlesToDisplay = isDetailedSearch ? articlesCollection?.articles
    : articlesCollection?.articles?.slice(0, slicerArticleNumber);
  const articlesToDisplayListView = isDetailedSearch ? articlesCollection?.articles
    : articlesCollection?.articles?.slice(0, 2);
  const industriesToDisplay = isDetailedSearch ? industriesCollection?.industries
    : industriesCollection?.industries?.slice(0, slicerNumber);
  const industriesToDisplayListView = isDetailedSearch ? industriesCollection?.industries
    : industriesCollection?.industries?.slice(0, 2);
  const buyerGroupsToDisplay = isDetailedSearch ? buyerGroupsCollection?.groups
    : buyerGroupsCollection?.groups?.slice(0, slicerGroupNumber);
  const buyerGroupsToDisplayListView = isDetailedSearch ? buyerGroupsCollection?.groups
    : buyerGroupsCollection?.groups?.slice(0, 2);
  const documentsToDisplay = isDetailedSearch ? documentCollection?.documents
    : documentCollection?.documents?.slice(0, 4);
  const documentsToDisplayListView = isDetailedSearch ? documentCollection?.documents
    : documentCollection?.documents?.slice(0, 2);

  // `hasMore` has to mean "more pages remain", not "we are on a detail page".
  // Passing the constant made InfiniteScroll keep firing `next` on every scroll
  // event after the list was exhausted, so paging never terminated.
  const hasMorePeople = isDetailedSearch
    && (peopleCollection?.persons?.length ?? 0) < (peopleCollection?.count ?? 0);
  const hasMoreCompanies = isDetailedSearch
    && (companiesCollection?.companies?.length ?? 0) < (companiesCollection?.count ?? 0);
  const hasMoreArticles = isDetailedSearch
    && (articlesCollection?.articles?.length ?? 0) < (articlesCollection?.count ?? 0);
  const hasMoreIndustries = isDetailedSearch
    && (industriesCollection?.industries?.length ?? 0) < (industriesCollection?.count ?? 0);
  const hasMoreBuyerGroups = isDetailedSearch
    && (buyerGroupsCollection?.groups?.length ?? 0) < (buyerGroupsCollection?.count ?? 0);
  const hasMoreDocuments = isDetailedSearch
    && (documentCollection?.documents?.length ?? 0) < (documentCollection?.count ?? 0);

  // Distinguish between the very first load (no people yet) and subsequent
  // pagination loads. On pagination we want to keep existing results visible
  // and only show bottom loaders instead of replacing the list with skeletons.
  const isInitialPeopleLoading = !globalSearchLoaded
    && ((personsToDisplay?.length ?? 0) === 0);

  const showInlineLoaderForPeople = (personsToDisplay?.length ?? 0) < 5
    && (loading || personsLoading);
  const showInlineLoaderForCompanies = (companiesToDisplay?.length ?? 0) < 5
    && (loading || companiesLoading);
  const showInlineLoaderForBuyerGroups = (buyerGroupsToDisplay?.length ?? 0) < 4
    && (loading || buyerGroupsLoading);
  const showInlineLoaderForIndustries = (industriesToDisplay?.length ?? 0) < 5
    && (loading);

  const isAllDataEmpty = () => globalSearchLoaded
    && companiesLoaded
    && personsLoaded
    && peopleCollection?.persons?.length === 0
    && companiesCollection?.companies?.length === 0
    && articlesCollection?.count === 0
    && industriesCollection?.industries?.length === 0
    && buyerGroupsCollection.groups?.length === 0
    && documentCollection?.documents?.length === 0;

  const isPersonDataEmpty = () => globalSearchLoaded
    && personsLoaded
    && peopleCollection?.persons?.length === 0;

  const isCompanyDataEmpty = () => globalSearchLoaded
    && companiesLoaded
    && companiesCollection?.companies?.length === 0;

  const isExtendedDataEmpty = () => {
    if ((extendedSection === 'person' && isPersonDataEmpty()) || (extendedSection === 'company' && isCompanyDataEmpty())) {
      return true;
    }
    if (extendedSection === 'company' && isCompanyDataEmpty()) {
      return true;
    }

    return false;
  };

  const isEmptyDataForOnBoarding = () => globalSearchLoaded
    && companiesLoaded
    && personsLoaded
    && peopleCollection?.persons?.length === 0
    && companiesCollection?.companies?.length === 0;

  const toggle = (flag: boolean) => {
    setOpenCreateModal(flag);
    if (!flag) setCreateFromSelection(false);
  };

  const noResultsFound = (isAllDataEmpty() || isExtendedDataEmpty()) && globalSearchLoaded;

  const isDrag = useCallback((a: boolean) => {
    if (a) dispatch(groupActions.setDropComplete(false));
    setDragging(a);
  }, [dispatch]);

  useEffect(() => {
    setShowNew(false);
    setOpenCreateModal(dragging);
    setCreateFromSelection(false);
  }, [dragging]);

  useEffect(() => {
    setActiveTab(extendedSection);
  }, [extendedSection]);

  useEffect(() => {
    const urlSort = searchParams.get('sort') as SortOrder | null;
    setSectionSortOrders(urlSort && extendedSection ? { [extendedSection]: urlSort } : {});
    setSectionPeopleFilters({});
    setSectionCompanyFilters({});
    setSectionArticleFilters({});
  }, [query]);

  useEffect(() => () => {
    if (!window.location.pathname.startsWith(SEARCH_PATHNAME_PREFIX)) {
      dispatch(actions.clearAllSearchSelections());
    }
  }, []);

  const data = useSelector(selectData);

  useEffect(() => {
    if (peopleCollection.persons && peopleCollection.persons?.length > 0) {
      dispatch(certificationActions.certificationAction({
        type: 'person_search',
        source: 'search',
        data,
      }));
    }
    if (companiesCollection.companies && companiesCollection.companies?.length > 0) {
      dispatch(certificationActions.certificationAction({
        type: 'company_search',
        source: 'search',
        data,
      }));
    }
  }, [peopleCollection, companiesCollection]);

  useEffect(() => {
    if (isSalesforce()) {
      switch (extendedSection) {
        case 'company':
          if (companiesToDisplay?.length === 1) {
            const [company] = companiesToDisplay;
            navigate(`${COMPANY_NEWS_ROUTE}${company.companyId}`, { replace: true });
          }
          break;
        case 'person':
          if (personsToDisplay?.length === 1) {
            const [person] = personsToDisplay;
            navigate(`${PERSONALITY_INSIGHTS_ROUTE}${person.personId}&personType=${person.personType || 'EXECUTIVE'}`, { replace: true });
          }
          break;
        default:
      }
    }
  }, [companiesToDisplay, personsToDisplay]);

  useEffect(() => {
    if ((prevExtendedSection === 'company'
      || prevExtendedSection === 'group'
      || prevExtendedSection === 'industry'
      || prevExtendedSection === 'article') && extendedSection === '') {
      setTimeout(() => {
        window.scrollTo({
          top: top - 120,
          left: 0,
          behavior: 'smooth',
        });
      }, 200);
    }
  }, [extendedSection]);

  const setTopCoordinates = (type: string) => {
    let className = '';
    if (type === 'company') {
      className = 'M-Companies';
    } else if (type === 'group') {
      className = 'M-Buyer';
    } else if (type === 'industry') {
      className = 'M-Industries';
    } else if (type === 'article') {
      className = 'M-Articles';
    }
    const offsets = document.getElementsByClassName(className)[0]?.getBoundingClientRect();
    setTop(offsets.top);
  };

  const createRoute = (param: string) => {
    window.scrollTo(0, 0);
    const params = new URLSearchParams(searchParams);
    [
      'industry', 'revenue', 'region', 'companySize',
      'jobTitle', 'jobLevel', 'personality', 'company',
      'startDate', 'endDate', 'type',
    ].forEach((filter) => params.delete(filter));
    params.set('extend', param);
    if (param === 'person' && sectionPeopleFilters[param]) {
      setPeopleFilterParams(params, sectionPeopleFilters[param]);
    }
    if (param === 'company' && sectionCompanyFilters[param]) {
      setCompanyFilterParams(params, sectionCompanyFilters[param]);
    }
    if (param === 'article' && sectionArticleFilters[param]) {
      setArticleFilterParams(params, sectionArticleFilters[param]);
    }
    const rememberedSort = sectionSortOrders[param];
    if (rememberedSort) {
      params.set('sort', rememberedSort);
    } else {
      params.delete('sort');
    }
    return navigate(`${pathname}?${params.toString()}`, {
      state: { enableBackButton: true, previousPath },
    });
  };

  const resetSectionPage = () => {
    switch (extendedSection) {
      case 'person':
        setPersonPage(1);
        break;
      case 'company':
        setCompanyPage(1);
        break;
      case 'article':
        setAtriclePage(1);
        break;
      case 'group':
        setBuyerGroupPage(1);
        break;
      case 'document':
        setDocumentPage(1);
        break;
      default:
        break;
    }
  };

  const handleSortChange = (order: SortOrder | null) => {
    setSectionSortOrders((prev) => {
      const next = { ...prev };
      if (order) {
        next[extendedSection] = order;
      } else {
        delete next[extendedSection];
      }
      return next;
    });

    const params = new URLSearchParams(searchParams);
    if (order) {
      params.set('sort', order);
    } else {
      params.delete('sort');
    }
    navigate(`${pathname}?${params.toString()}`, {
      state: { enableBackButton: true, previousPath },
    });

    dispatch(actions.globalSearchResultsResetSection(extendedSection));
    resetSectionPage();

    const obj: SearchResultsRequest = {
      query: `${extendedSection}:${queryString}`,
      screenName,
      page: 1,
      ...(peopleFiltersFromUrl.jobTitle && { jobTitles: peopleFiltersFromUrl.jobTitle }),
      ...(peopleFiltersFromUrl.jobLevel && { jobLevels: peopleFiltersFromUrl.jobLevel.join(',') }),
      ...(peopleFiltersFromUrl.personality && { personalityTypes: peopleFiltersFromUrl.personality.join(',') }),
      ...(peopleFiltersFromUrl.company && { companies: peopleFiltersFromUrl.company }),
      ...(peopleFiltersFromUrl.region && { regions: peopleFiltersFromUrl.region }),
      ...(companyFiltersFromUrl.industry && { industries: companyFiltersFromUrl.industry }),
      ...(companyFiltersFromUrl.region && { regions: companyFiltersFromUrl.region }),
      ...(companyFiltersFromUrl.revenue && { revenues: companyFiltersFromUrl.revenue }),
      ...(companyFiltersFromUrl.companySize && { companySizes: companyFiltersFromUrl.companySize }),
      ...(order && { sortOrder: order }),
      defaultLanguage: getLangCookie(),
    };
    dispatch(actions.globalSearchResults(obj));
  };

  useEffect(() => {
    const node = document.querySelector('body');
    return (clusterDrawerOpen || groupDrawerOpen
      || selectedCompanies.length > 0 || selectedPeople.length > 0)
      ? node?.classList.add('body-drawer-toggle') : node?.classList.remove('body-drawer-toggle');
  }, [clusterDrawerOpen, groupDrawerOpen, selectedCompanies, selectedPeople, extendedSections]);

  useEffect(() => {
    dispatch(clusterActions.resetClusterDetails());
  }, [dispatch])

  const applyDateFilterHandler = (value: DateRangeValue) => {
    setSectionArticleFilters((prev) => {
      const next = { ...prev };
      if (hasRememberedArticleFilter(value)) {
        next.article = value;
      } else {
        delete next.article;
      }
      return next;
    });
    const params = new URLSearchParams(searchParams);
    if (value) {
      params.set('startDate', value.startDate);
      params.set('endDate', value.endDate);
      params.set('type', value.type);
    }
    navigate(`${pathname}?${params.toString()}`, {
      state: { enableBackButton: true, previousPath },
    });
    dispatch(filterActions.setArticleFilters(value));
    dispatch(actions.globalSearchResultsResetSection('article'));
    resetSectionPage();

    const request: SearchResultsRequest = {
      query: `article: ${queryString}`,
      screenName,
      page: 1,
      startDate: value.startDate,
      endDate: value.endDate,
      ...(isDetailedSearch && extendedSection === 'article' && { type: 'News' }),
      defaultLanguage: getLangCookie(),
    }
    dispatch(actions.globalSearchResults(request));

  }

  const isAllSelected = (selected: string[], allOptions: string[]) => {
    return (
      selected.length === allOptions.length &&
      selected.every((item) => allOptions.includes(item))
    );
  }

  const handleCompanyFiltersApply = (companyFilters: CompanyFiltersType) => {
    setSectionCompanyFilters((prev) => {
      const next = { ...prev };
      if (hasRememberedSelection(companyFilters)) {
        next.company = companyFilters;
      } else {
        delete next.company;
      }
      return next;
    });
    dispatch(filterActions.setCompanyFilters(companyFilters));
    dispatch(actions.globalSearchResultsResetSection('company'));
    resetSectionPage();

    const params = new URLSearchParams(searchParams);
    ['industry', 'revenue', 'region', 'companySize'].forEach((category) => params.delete(category));
    setCompanyFilterParams(params, companyFilters);
    navigate(`${pathname}?${params.toString()}`);;

    const request: SearchResultsRequest = {
      query: `${extendedSection}:${queryString}`,
      screenName,
      page: 1,
      ...sortOrder && { sortOrder },
      ...companyFilters.industry && { industries: companyFilters.industry },
      ...companyFilters.region && { regions: companyFilters.region },
      ...companyFilters.revenue && { revenues: companyFilters.revenue },
      ...companyFilters.companySize && { companySizes: companyFilters.companySize },
      defaultLanguage: getLangCookie(),
    };
    dispatch(actions.globalSearchResults(request));
  };

  useEffect(() => {
    dispatch(filterActions.setCompanyFilters(companyFiltersFromUrl));
  }, [companyFiltersFromUrl, dispatch]);

  useEffect(() => {
    dispatch(filterActions.getSearchContentDistincts({
      ...distinctCompanySearchTerm && { search: distinctCompanySearchTerm },
      query: queryString,
      type: 'companies',
      page: 1,
    }))
  }, [distinctCompanySearchTerm, queryString]);

  useEffect(() => {
    dispatch(filterActions.getSearchContentDistincts({
      ...distinctDesignationSearchTerm && { search: distinctDesignationSearchTerm },
      query: queryString,
      type: 'designations',
      page: 1,
    }))
  }, [distinctDesignationSearchTerm, queryString]);

  const fetchMoreDistinctCompanies = (searchTerm?: string) => {
    dispatch(filterActions.getSearchContentDistincts({
      ...searchTerm && { search: searchTerm },
      query: queryString,
      type: 'companies',
      page: distinctCompanyPage + 1,
    }))
  };

  const fetchMoreDistinctDesignations = (searchTerm?: string) => {
    dispatch(filterActions.getSearchContentDistincts({
      ...searchTerm && { search: searchTerm },
      query: queryString,
      type: 'designations',
      page: distinctDesignationPage + 1,
    }))
  };

  const handlePeopleFilterApply = (peopleFilters: PeopleFilterSelections) => {
    setSectionPeopleFilters((prev) => {
      const next = { ...prev };
      if (hasRememberedSelection(peopleFilters)) {
        next.person = peopleFilters;
      } else {
        delete next.person;
      }
      return next;
    });
    const selectedPeopleFilters = {
      jobTitle: peopleFilters.jobTitle ?? [],
      jobLevel: peopleFilters.jobLevel ?? [],
      personality: peopleFilters.personality ?? [],
      company: peopleFilters.company ?? [],
      region: peopleFilters.region ?? [],
    };

    dispatch(actions.globalSearchResultsResetSection('person'));
    resetSectionPage();

    const params = new URLSearchParams(searchParams);
    ['jobTitle', 'jobLevel', 'personality', 'company', 'region'].forEach((category) => params.delete(category));
    setPeopleFilterParams(params, peopleFilters);

    navigate(`${pathname}?${params.toString()}`, {
      state: { enableBackButton: true, previousPath },
    });
    const request: SearchResultsRequest = {
      query: `${extendedSection}: ${queryString}`,
      screenName,
      page: 1,
      filterApplied: true,
      ...sortOrder && { sortOrder },
      ...selectedPeopleFilters.jobTitle.length && { jobTitles: selectedPeopleFilters.jobTitle },
      ...selectedPeopleFilters.jobLevel.length && { jobLevels: selectedPeopleFilters.jobLevel.join(',') },
      ...selectedPeopleFilters.personality.length && { personalityTypes: selectedPeopleFilters.personality.join(',') },
      ...selectedPeopleFilters.company.length && { companies: selectedPeopleFilters.company },
      ...selectedPeopleFilters.region.length && { regions: selectedPeopleFilters.region },
      defaultLanguage: getLangCookie(),
    };
    dispatch(actions.globalSearchResults(request));
  }
  return (
    <Wrapper>
      {
        hideNavbar ? null : (
          <>
            <NavBarPrimary headerClassName="box-shadow no-overflow-on-header">
              <div className="left-side-wrap">
                {enableBackButton && (
                  <BackIcon onClick={() => {
                    const path = isDetailedSearch ? `${pathname}?query=${query}`
                      : previousPath;
                    navigate(path, {
                      state: isDetailedSearch ? { enableBackButton: true, previousPath }
                        : { previousPath },
                    });
                  }}
                  />
                )}
                <h1 className="heading">Results</h1>
              </div>
              <div className="right-side-wrap">
                <GlobalSearch iconMode={isTablet} />
                <DrawerAlerts />
                <AccountPopOver />
              </div>
            </NavBarPrimary>
            <SubNavBarPrimary>
              <div className="heading-inner-page tabs-placeholder wrap-slider hidden-scroll">
                <div className="head-wrap" />
                <div className="tips-placeholder ml-0">
                  {loading && !extendedSection ? (
                    <div className="tabs-wrapper">
                      {[1, 2, 3, 4, 5].map(() => (
                        <SkeletonCustom height="30px" width="110px" margin="0px 10px 0px 0px" marginSm="0px 10px 0px 0px" />
                      ))}
                    </div>
                  )
                    : (
                      <div className="tabs-wrapper">
                        {isSalesforce() && isDetailedSearch ? (
                          <>
                            {(peopleCollection?.count > 0 || isPeopleFilterApplied) && extendedSection === 'person' ? (
                              <span
                                className={classNames('tabs-item', { active: (activeTab === 'person') })}
                                onClick={() => createRoute('person')}
                                onKeyDown={() => createRoute('person')}
                                role="button"
                                tabIndex={0}
                              >
                                People
                              </span>
                            ) : null}

                            {(companiesCollection?.count > 0 || isCompanyFilterApplied) && extendedSection === 'company'
                              ? (
                                <span
                                  className={classNames('tabs-item', { active: (activeTab === 'company') })}
                                  onClick={() => createRoute('company')}
                                  onKeyDown={() => createRoute('company')}
                                  role="button"
                                  tabIndex={0}
                                >
                                  Companies
                                </span>
                              ) : null}
                          </>
                        ) : (
                          <>
                            {peopleCollection?.count > 0 || sortOrder !== null || isPeopleFilterApplied ? (
                              <span
                                className={classNames('tabs-item', { active: (activeTab === 'person') })}
                                onClick={() => createRoute('person')}
                                onKeyDown={() => createRoute('person')}
                                role="button"
                                tabIndex={0}
                              >
                                People
                              </span>
                            ) : null}

                            {companiesCollection?.count > 0 || sortOrder !== null || isCompanyFilterApplied
                              ? (
                                <span
                                  className={classNames('tabs-item', { active: (activeTab === 'company') })}
                                  onClick={() => createRoute('company')}
                                  onKeyDown={() => createRoute('company')}
                                  role="button"
                                  tabIndex={0}
                                >
                                  Companies
                                </span>
                              ) : null}

                            {buyerGroupsCollection?.count > 0 || sortOrder !== null ? (
                              <span
                                className={classNames('tabs-item', { active: (activeTab === 'group') })}
                                onClick={() => createRoute('group')}
                                onKeyDown={() => createRoute('group')}
                                role="button"
                                tabIndex={0}
                              >
                                BRM
                              </span>
                            ) : null}

                            {documentCollection.count > 0 || sortOrder !== null
                              ? (
                                <span
                                  className={classNames('tabs-item', { active: (activeTab === 'document') })}
                                  onClick={() => createRoute('document')}
                                  onKeyDown={() => createRoute('document')}
                                  role="button"
                                  tabIndex={0}
                                >
                                  Doc Hub
                                </span>
                              ) : null}

                            {industriesCollection?.count > 0 && !hideIndustries
                              ? (
                                <span
                                  className={classNames('tabs-item', { active: (activeTab === 'industry') })}
                                  onClick={() => createRoute('industry')}
                                  onKeyDown={() => createRoute('industry')}
                                  role="button"
                                  tabIndex={0}
                                >
                                  Industries
                                </span>
                              ) : null}

                            {(articlesCollection?.count > 0 || isArticleFilterApplied) && !hideArticles
                              ? (
                                <span
                                  className={classNames('tabs-item', { active: (activeTab === 'article') })}
                                  onClick={() => createRoute('article')}
                                  onKeyDown={() => createRoute('article')}
                                  role="button"
                                  tabIndex={0}
                                >
                                  Articles
                                </span>
                              ) : null}
                          </>
                        )}
                      </div>
                    )}

                </div>
                <div className="right-side-sub-header">
                  {
                    (!noResultsFound
                      || (extendedSection === 'person' && isPeopleFilterApplied)
                      || (extendedSection === 'company' && isCompanyFilterApplied))
                    && isDetailedSearch && SORTABLE_SECTIONS.includes(extendedSection)
                    && (extendedSection !== 'person' || (linkedinpersonLoaded &&
                      peopleCollection.linkedInCount === 0)) && (
                      <div className={classNames('global-search-sort')}>
                        <CustomSort value={sortOrder} onSortChange={handleSortChange} iconMode={isTablet} disabled={loading} />
                      </div>
                    )
                  }
                  {
                    ((!noResultsFound || isPeopleFilterApplied)
                      && extendedSection === 'person'
                      && (peopleCollection.linkedInCount === 0 && linkedinpersonLoaded)) && (
                      <div className={classNames('people-filter')}>
                        <PeopleFilters
                          jobLevelData={filters?.jobLevels}
                          personalityData={filters?.personalityTypes}
                          regionData={filters?.regions}
                          designationData={distinctDesignationFilters}
                          companyData={distinctCompanyFilters}
                          onFetchMoreCompanies={fetchMoreDistinctCompanies}
                          onFetchMoreDesignations={fetchMoreDistinctDesignations}
                          hasMoreCompanies={hasMoreDistinctCompanies}
                          hasMoreDesignations={hasMoreDistinctDesignations}
                          companiesLoading={distinctCompanyLoading}
                          designationsLoading={distinctDesignationLoading}
                          initialFilters={peopleFiltersFromUrl}
                          onApply={handlePeopleFilterApply}
                          disabled={loading}
                        />
                      </div>
                    )
                  }
                  {
                    ((!noResultsFound || isCompanyFilterApplied)
                      && extendedSection === 'company'
                      && companiesCollection.linkedInCount === 0) && (
                      <div className={classNames('company-filter')}>
                        <CompanyFilters
                          revenueData={filters?.companyRevenue}
                          companySizeData={filters?.companySizes}
                          industryData={filters?.industries}
                          regionData={filters?.regions}
                          initialFilters={companyFiltersFromUrl}
                          onApply={handleCompanyFiltersApply}
                          disabled={loading}
                        />
                      </div>
                    )
                  }
                  {
                    ((!noResultsFound || isArticleFilterApplied)
                      && extendedSection === 'article' && !loading) && (
                      <DateRangeFilter
                        defaultRange={searchParams.get('type') || 'All Time'}
                        startDate={articleFilterStartDate}
                        endDate={articleFilterEndDate}
                        onChange={applyDateFilterHandler}
                        disabled={loading}
                      />
                    )
                  }

                  <div className={classNames('view-tabs', {
                    notdisabledTabs: true,
                  })}
                  >
                    <ViewTabs
                      disabled={false}
                      listView={isListView}
                    />
                  </div>
                </div>
              </div>
            </SubNavBarPrimary>
          </>
        )
      }
      <div className="container placement-logic">
        <div className={classNames('styleing-wrapper', { fancyBox: !window.location.pathname?.includes(`/${ONBOARDING}`) || !isSalesforce() })}>
          {
            window.location.pathname?.includes(`/${ONBOARDING}`) ? (
              <>
                {isCompaniesSectionVisible ? (
                  <InfiniteScroll
                    hasMore={hasMoreCompanies}
                    dataLength={companiesCollection?.companies?.length ?? 0}
                    next={fetchMoreCompanies}
                    loader={false && <SearchCompanySkeletonBlock sliceFlag={!isDetailedSearch} />}
                    className="o-x-hidden spacer"
                  >
                    <CompaniesSection
                      heading={companiesCollection?.title}
                      hideDefaultBackground
                      companiesCollection={companiesToDisplay}
                      loading={!companiesLoaded}
                      companyCount={companiesCollection.companies}
                      count={companiesCollection.count}
                      query={query?.replace(/&/g, '%26')}
                      showLoaderForLessResults={showInlineLoaderForCompanies}
                      {...(showInlineLoaderForCompanies
                        && {
                        numberOfLoaderForLessResults:
                          10 - (companiesToDisplay?.length ?? 0),
                      })}
                      disableNavigation
                    />
                  </InfiniteScroll>
                ) : <> </>}
                {isPeopleSectionVisible ? (
                  <InfiniteScroll
                    hasMore={hasMorePeople}
                    dataLength={peopleCollection?.persons?.length ?? 0}
                    next={fetchMorePeople}
                    loader={false && <SearchPersonSkeletonBlock sliceFlag={!isDetailedSearch} />}
                    className="o-x-hidden spacer"
                  >
                    <PeopleSection
                      heading={peopleCollection?.title}
                      hideDefaultBackground
                      peopleCollection={personsToDisplay}
                      loading={isDetailedSearch ? !personsLoaded : !globalSearchLoaded}
                      peopleCount={peopleCollection.persons}
                      count={peopleCollection.count}
                      query={query?.replace(/&/g, '%26')}
                      showLoaderForLessResults={showInlineLoaderForPeople}
                      {...(showInlineLoaderForPeople
                        && { numberOfLoaderForLessResults: 10 - (personsToDisplay?.length ?? 0) })}
                      invertFollow
                      inGlobalSearch
                      bothSearchLoading={!personsLoaded || !globalSearchLoaded}
                    />
                  </InfiniteScroll>
                ) : <> </>}

              </>
            ) : (
              <>
                {isSalesforce() ? '' : (
                  <DrawerPeopleGroup
                    openNewCreate={openCreateModal}
                    setOpenNew={toggle}
                    showNew={showNew}
                    toggleShowNew={(bool: boolean) => setShowNew(bool)}
                    noButton
                    drag={dragging}
                    fromSearchSelection={createFromSelection}
                  />
                )}
                {isEnterprise && <DrawerPersonas />}
                {isPeopleSectionVisible && isListView ? (
                  <InfiniteScroll
                    hasMore={hasMorePeople}
                    dataLength={peopleCollection?.persons?.length ?? 0}
                    next={fetchMorePeople}
                    loader={false && <SearchPersonSkeletonBlock sliceFlag={!isDetailedSearch} />}
                    className={classNames('o-x-hidden spacer', { 'o-y-hidden': !isDetailedSearch })}
                  >
                    <PeopleSectionListView
                      heading={peopleCollection?.title}
                      peopleCollection={personsToDisplayListView}
                      loading={isInitialPeopleLoading}
                      peopleCount={peopleCollection?.persons}
                      count={peopleCollection.count}
                      {...(showInlineLoaderForPeople
                        && { numberOfLoaderForLessResults: 10 - (personsToDisplay?.length ?? 0) })}
                      invertFollow
                      inGlobalSearch
                      query={query?.replace(/&/g, '%26')}
                      forceVisible={isPeopleFilterApplied}
                    />
                  </InfiniteScroll>
                ) : <></>}
                {!peopleCollection.persons?.length && personsLoaded && globalSearchLoaded && !extendedSection
                  && !isPeopleFilterApplied
                  && !isAllDataEmpty() && !isExtendedDataEmpty() ? (
                  <NoPersonFound>No Person found</NoPersonFound>
                ) : <> </>}
                {isPeopleSectionVisible && !isListView ? (
                  <InfiniteScroll
                    hasMore={hasMorePeople}
                    dataLength={peopleCollection?.persons?.length ?? 0}
                    next={fetchMorePeople}
                    loader={false && <SearchPersonSkeletonBlock sliceFlag={!isDetailedSearch} />}
                    className={classNames('o-x-hidden M-People', {
                      detailPage: isDetailedSearch,
                      hideArea: peopleCollection.count === 0 && !isPeopleFilterApplied,
                    })}
                  >
                    <PeopleSection
                      heading={peopleCollection?.title}
                      hideDefaultBackground
                      peopleCollection={personsToDisplay}
                      loading={isInitialPeopleLoading}
                      peopleCount={peopleCollection.persons}
                      count={peopleCollection.count}
                      query={query?.replace(/&/g, '%26')}
                      inGlobalSearch
                      showLoaderForLessResults={showInlineLoaderForPeople}
                      {...(showInlineLoaderForPeople
                        && { numberOfLoaderForLessResults: 10 - (personsToDisplay?.length ?? 0) })}
                      invertFollow
                      bothSearchLoading={!personsLoaded || !globalSearchLoaded}
                      isDrag={isDrag}
                      forceVisible={isPeopleFilterApplied}
                    />
                  </InfiniteScroll>
                ) : (
                  ((personsLoading || !personsLoaded) && isSalesforce()) && (
                    isListView
                      ? (
                        <LoaderWrapper className="loader-wrapper">
                          <div className="main">
                            <img className="loader-style" src={extendedSearchLoader} alt="extended-loader" />
                            <p className="text">
                              {'Uncovering more People using xiQ\'s extended Search.'}
                            </p>
                          </div>
                        </LoaderWrapper>
                      )
                      : <ExtendedSearchLoader />
                  )
                )}
                {isCompaniesSectionVisible && isListView ? (
                  <InfiniteScroll
                    hasMore={hasMoreCompanies}
                    dataLength={companiesCollection?.companies?.length ?? 0}
                    next={fetchMoreCompanies}
                    loader={false && <SearchCompanySkeletonBlock sliceFlag={!isDetailedSearch} />}
                    className={classNames(
                      'o-x-hidden  M-Companies spacer',
                      { detailPage: isDetailedSearch },
                      { 'o-y-hidden': !isDetailedSearch },
                    )}
                  >
                    <CompaniesSectionListView
                      heading={companiesCollection?.title}
                      companiesCollection={companiesToDisplayListView}
                      loading={!globalSearchLoaded}
                      companyCount={companiesCollection.companies}
                      count={companiesCollection.count}
                      listView={isListView}
                      inGlobalSearch
                      query={query?.replace(/&/g, '%26')}
                      forceVisible={isCompanyFilterApplied}
                    />
                  </InfiniteScroll>
                ) : <> </>}
                {isCompaniesSectionVisible && !isListView ? (
                  <InfiniteScroll
                    hasMore={hasMoreCompanies}
                    dataLength={companiesCollection?.companies?.length ?? 0}
                    next={fetchMoreCompanies}
                    loader={false && <SearchCompanySkeletonBlock sliceFlag={!isDetailedSearch} />}
                    className={classNames(
                      'o-x-hidden  M-Companies spacer',
                      { detailPage: isDetailedSearch },
                    )}
                  >
                    <CompaniesSection
                      heading={companiesCollection?.title}
                      hideDefaultBackground
                      companiesCollection={companiesToDisplay}
                      loading={!globalSearchLoaded}
                      companyCount={companiesCollection.companies}
                      count={companiesCollection.count}
                      query={query?.replace(/&/g, '%26')}
                      listView={isListView}
                      inGlobalSearch
                      showLoaderForLessResults={showInlineLoaderForCompanies}
                      {...(showInlineLoaderForCompanies
                        // eslint-disable-next-line max-len
                        && { numberOfLoaderForLessResults: 10 - (companiesToDisplay?.length ?? 0) })}
                      setCompanyTop={setTopCoordinates}
                      forceVisible={isCompanyFilterApplied}
                    />
                  </InfiniteScroll>
                ) : <> </>}

                {isBuyerGroupsSectionVisible && isListView ? (
                  <InfiniteScroll
                    hasMore={hasMoreBuyerGroups}
                    dataLength={buyerGroupsCollection?.groups?.length ?? 0}
                    next={fetchMoreBuyerGroups}
                    loader={false && (
                      <SearchBuyerGroupSkeletonBlock
                        sliceFlag={!isDetailedSearch}
                      />
                    )}
                    className={classNames(
                      'o-x-hidden o-y-hidden M-Buyer spacer',
                      { detailPage: isDetailedSearch },
                    )}
                  >
                    <BuyerGroupsSectionListView
                      heading={buyerGroupsCollection?.title}
                      buyerGroupsCollection={buyerGroupsToDisplayListView}
                      loading={!globalSearchLoaded}
                      buyerGroupCount={buyerGroupsCollection.groups}
                      count={buyerGroupsCollection.count}
                      inGlobalSearch
                      query={query?.replace(/&/g, '%26')}
                    />
                  </InfiniteScroll>
                ) : (<> </>)}

                {isBuyerGroupsSectionVisible && !isListView ? (
                  <InfiniteScroll
                    hasMore={hasMoreBuyerGroups}
                    dataLength={buyerGroupsCollection?.groups?.length ?? 0}
                    next={fetchMoreBuyerGroups}
                    loader={false && (
                      <SearchBuyerGroupSkeletonBlock
                        sliceFlag={!isDetailedSearch}
                      />
                    )}
                    className={classNames(
                      'o-x-hidden o-y-hidden M-Buyer spacer',
                      { detailPage: isDetailedSearch },
                    )}
                  >
                    <BuyerGroupsSection
                      heading={buyerGroupsCollection?.title}
                      buyerGroupsCollection={buyerGroupsToDisplay}
                      loading={!globalSearchLoaded}
                      buyerGroupCount={buyerGroupsCollection.groups}
                      count={buyerGroupsCollection.count}
                      query={query?.replace(/&/g, '%26')}
                      inGlobalSearch
                      showLoaderForLessResults={showInlineLoaderForBuyerGroups}
                      {...(showInlineLoaderForBuyerGroups && {
                        numberOfLoaderForLessResults:
                          8 - (buyerGroupsToDisplay?.length ?? 0),
                      })}
                      setGroupTop={setTopCoordinates}
                    />

                  </InfiniteScroll>
                ) : (<> </>
                )}
                {isDocumethubSectionVisible && isListView ? (
                  <InfiniteScroll
                    hasMore={hasMoreDocuments}
                    dataLength={documentCollection?.documents?.length ?? 0}
                    next={fetMoreDocuments}
                    loader={false}
                    className={classNames(
                      'o-x-hidden o-y-hidden',
                    )}
                  >
                    <DocumentHubListView
                      heading={documentCollection?.title}
                      count={documentCollection?.count}
                      loading={!globalSearchLoaded}
                      entitiesCount={documentCollection.documents}
                      entitiesToDisplay={documentsToDisplayListView}
                      inGlobalSearch
                      searchQuery={query?.replace(/&/g, '%26')}
                    />
                  </InfiniteScroll>
                ) : null}
                {isDocumethubSectionVisible && !isListView
                  ? (
                    <InfiniteScroll
                      hasMore={hasMoreDocuments}
                      dataLength={documentCollection?.documents?.length ?? 0}
                      next={fetMoreDocuments}
                      loader={false}
                    >
                      <DocumentHub
                        heading={documentCollection?.title}
                        count={documentCollection?.count}
                        documentsCount={documentCollection?.documents}
                        inGlobalSearch
                        documentsToDisplay={documentsToDisplay}
                        globalSearchloading={!isDetailedSearch && loading}
                        searchQuery={query?.replace(/&/g, '%26')}
                      />
                    </InfiniteScroll>
                  ) : null}
              </>
            )
          }
          {
            isIndustriesSectionVisible && isListView ? (
              <InfiniteScroll
                hasMore={hasMoreIndustries}
                dataLength={industriesCollection?.industries?.length ?? 0}
                next={fetchMoreIndustries}
                loader={false && <SearchIndustrySkeletonBlock sliceFlag={!isDetailedSearch} />}
                className={classNames('o-x-hidden M-Industries spacer', { detailPage: isDetailedSearch })}
              >
                <IndustriesSectionListView
                  heading={industriesCollection?.title}
                  industriesCollection={industriesToDisplayListView}
                  loading={!globalSearchLoaded}
                  industryCount={industriesCollection.industries}
                  count={industriesCollection.count}
                  query={query?.replace(/&/g, '%26')}
                  showUnfollow
                  inGlobalSearch
                />
              </InfiniteScroll>
            ) : (<> </>)

          }
          {
            isIndustriesSectionVisible && !hideIndustries && !isListView ? (
              <InfiniteScroll
                hasMore={hasMoreIndustries}
                dataLength={industriesCollection?.industries?.length ?? 0}
                next={fetchMoreIndustries}
                loader={false && <SearchIndustrySkeletonBlock sliceFlag={!isDetailedSearch} />}
                className={classNames('o-x-hidden M-Industries spacer', { detailPage: isDetailedSearch })}
              >
                <IndustriesSection
                  heading={industriesCollection?.title}
                  hideDefaultBackground
                  query={query?.replace(/&/g, '%26')}
                  industriesCollection={industriesToDisplay}
                  loading={!isDetailedSearch && loading}
                  industryCount={industriesCollection.industries}
                  count={industriesCollection.count}
                  showLoaderForLessResults={showInlineLoaderForIndustries}
                  {...(showInlineLoaderForIndustries
                    && { numberOfLoaderForLessResults: 10 - (industriesToDisplay?.length ?? 0) })}
                  showUnfollow
                  setIndustryTop={setTopCoordinates}
                  inGlobalSearch
                />
              </InfiniteScroll>
            ) : <> </>
          }
          {
            isArticlesSectionVisible && isListView ? (
              <InfiniteScroll
                hasMore={hasMoreArticles}
                dataLength={articlesCollection?.articles?.length ?? 0}
                next={fetchMoreArticles}
                loader={false && <SocialCardSkeleton />}
                className={classNames(
                  'o-x-hidden o-y-hidden M-Articles',
                  {
                    spacer:
                      articlesToDisplay && articlesToDisplay?.length < slicerArticleNumber / 2,
                  },
                )}
              >
                <ArticlesSectionListView
                  heading={articlesCollection.title}
                  articlesCollection={articlesToDisplayListView}
                  loading={!globalSearchLoaded}
                  articleCount={articlesCollection.articles}
                  count={articlesCollection.count}
                  inGlobalSearch
                  query={query?.replace(/&/g, '%26')}
                />
              </InfiniteScroll>
            ) : (<> </>)
          }
          {
            isArticlesSectionVisible && !hideArticles && !isListView ? (
              <InfiniteScroll
                hasMore={hasMoreArticles}
                dataLength={articlesCollection?.articles?.length ?? 0}
                next={fetchMoreArticles}
                loader={false && <SocialCardSkeleton />}
                className={classNames(
                  'o-x-hidden o-y-hidden M-Articles',
                  {
                    spacer:
                      articlesToDisplay && articlesToDisplay?.length < slicerArticleNumber / 2,
                  },
                )}
              >
                <ArticlesSection
                  heading={articlesCollection.title}
                  articlesCollection={articlesToDisplay}
                  loading={!isDetailedSearch && loading}
                  query={query?.replace(/&/g, '%26')}
                  articleCount={articlesCollection.articles}
                  count={articlesCollection.count}
                  setArticleTop={setTopCoordinates}
                  inGlobalSearch
                />
              </InfiniteScroll>
            ) : <> </>
          }
          {((!onboardingSearchFlag && isAllDataEmpty()) || isExtendedDataEmpty()) && globalSearchLoaded ? <SearchNoResultFoundWidget marginTop="250px" hasFilters={hasAppliedFilters} /> : null}
          {
            onboardingSearchFlag
              && isEmptyDataForOnBoarding() ? <SearchNoResultFoundWidget marginTop="100px" /> : null
          }

        </div>

        {isDetailedSearch && extendedSection === 'person' ? (
          <SelectionActionFooter
            selectedCount={selectedPeople.length}
            buttonTitle="Add to Buyer Group"
            itemLabel="person"
            itemLabelPlural="people"
            onButtonClick={handleAddToBuyerGroup}
            onClearSelection={() => dispatch(actions.clearSelectedPeople())}
          />
        ) : null}

        {isDetailedSearch && extendedSection === 'company' ? (
          <>
            <SelectionActionFooter
              selectedCount={selectedCompanies.length}
              buttonTitle="Create Account Cluster"
              itemLabel="company"
              itemLabelPlural="companies"
              onButtonClick={handleCreateAccountCluster}
              onClearSelection={() => dispatch(actions.clearSelectedCompanies())}
            />
            <DrawerAccountCluster
              toggleDrawer={toggleDrawer}
              mode="create"
              inGlobalSearch
            />
          </>
        ) : null}

      </div>
      {showGlobalGilroy
        ? (
          <Gilroy gilroyStates={gilroyStates} gilroyActions={gilroyActions} />
        ) : null}
    </Wrapper>
  );
};

Search.defaultProps = defaultProps;
export default Search;